import styled, { css } from 'styled-components/macro';

import { ReactComponent as SpinnerSvg } from '@src/assets/icons/spinner.svg';

export interface SpinnerProps {
  /** Size of the spinner. */
  size?: 'sm' | 'lg';
}

const StyledSpinner = styled(SpinnerSvg)<SpinnerProps>`
  /* Default size is for 'sm' size. */
  --spinner-size: var(--space-6);

  ${({ size }) =>
    size === 'lg' &&
    css`
      --spinner-size: var(--space-8);
    `}

  width: var(--spinner-size);
  height: var(--spinner-size);
  color: var(--color-secondary-blue);
  display: block;
`;

/**
 * A simple spinner component that can be displayed at multiple sizes.
 * It should not be used directly as it requires outer markup to make it an accessible spinner.
 */
export function Spinner({ size = 'sm' }: SpinnerProps) {
  return <StyledSpinner size={size} aria-hidden />;
}
